const known = (value: unknown) => value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value));

/**
 * A course / lecture's place in the curriculum: tab order › section order ›
 * position inside the section ("T1 › S2 › #3"). Positions are per section, so
 * this is what identifies a course's place in the whole classroom.
 * "—" when the course has no section or no position.
 */
export const formatCurriculumPosition = (
	tabOrder?: number | null,
	sectionOrder?: number | null,
	position?: number | string | null
) => {
	if (!known(sectionOrder) || !known(position)) return '—';
	const tab = known(tabOrder) ? `T${tabOrder} › ` : '';
	return `${tab}S${sectionOrder} › #${Number(position)}`;
};

export default formatCurriculumPosition;
